import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { isEmpty, cloneDeep, isEqual } from 'lodash';
import { CPATTERN, DefaultColor } from '../../shared/helpers/app.constants';
import { ChannelMappingService, LoadingOverlayService } from '../../shared/services';
import { InputTagsComponent } from '../../shared/components';
import { Helper } from '../../shared/helpers/helper';
import { Subscription } from 'rxjs';
import { IEditChannelMappedDto } from '../../shared/models';

@Component({
  selector: 'app-channel-mapping-edit',
  templateUrl: './channel-mapping-edit.component.html',
  styleUrls: ['./channel-mapping-edit.component.scss']
})
export class ChannelMappingEditComponent implements OnInit, OnDestroy {

  defaultColor: any[] = DefaultColor;
  subscriptions: Subscription[] = [];

  form: FormGroup;
  channelName: AbstractControl;
  color: AbstractControl;
  selectedChannels = [];

  @ViewChild('inputTagRef')
  private inputTagRef: InputTagsComponent;

  @Input() selectedItem;
  @Input() currentCompanyId;

  originFormValue: any;
  originSelectedChannels: { name: string }[] = [];

  constructor(
    protected dialogRef: NbDialogRef<any>,
    private fb: FormBuilder,
    private channelMappingService: ChannelMappingService,
    private loadingOverlayService: LoadingOverlayService,
  ) { }

  ngOnInit() {
    this.createForm();
    if (this.selectedItem && !isEmpty(this.selectedItem.mappedChannel)) {
      this.selectedChannels = this.selectedItem.mappedChannel.map(name => {
        return { name };
      });
      this.originSelectedChannels = cloneDeep(this.selectedChannels);
    }
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  createForm() {
    this.form = this.fb.group({
      channelName: new FormControl('', [
        Validators.required, Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(CPATTERN.CHANNEL_MAPPING_NAME),
      ]),
      color: new FormControl('')
    });
    this.channelName = this.form.controls['channelName'];
    this.color = this.form.controls['color'];
    // set values
    if (this.selectedItem && this.selectedItem.name) {
      this.channelName.setValue(this.selectedItem.name);
      this.color.setValue(this.selectedItem.color);
      this.originFormValue = cloneDeep(this.form.value);
    }
  }

  close() {
    this.dialogRef.close();
  }

  submitForm(event) {
    if (this.form.valid) {
      if (this.isChangeOriginValues()) {
        const data = { ...this.form.value, channelNames: [] };
        data.channelNames = this.selectedChannels.map(item => item.name);

        if (this.selectedItem && data && data.channelName) {
          this.loadingOverlayService.show();
          const reqPayload: IEditChannelMappedDto = {
            channelMappedName: this.selectedItem.name,
            color: data.color,
            companyId: this.currentCompanyId
          };

          this.channelMappingService.update(reqPayload)
            .subscribe(res => {
              this.dialogRef.close(data);
              this.loadingOverlayService.hide();
            }, err => {
              this.loadingOverlayService.hide();
              return err;
            });
        }
      } else {
        this.dialogRef.close();
      }
    }
  }

  selectColor(event) {
    this.color.setValue(event);
  }

  isChangeOriginValues() {
    return !isEqual(this.originFormValue, this.form.value) || !isEqual(this.originSelectedChannels, this.selectedChannels);
  }

}
